// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1wEUR","question":"Question_question__3ukSe","description":"Question_description__2O6YG"};